/**
 * Firebase Configuration
 * 
 * This file contains the Firebase configuration for the Survivor fantasy league application.
 * Updated for the new Firebase project: fantasy-survivor-cce38
 */

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDx7zcMztW3_V1Hjimbay-f9IQCZLjadHw",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'aokplay.com',
  projectId: "fantasy-survivor-cce38",
  storageBucket: "fantasy-survivor-cce38.firebasestorage.app",
  messagingSenderId: "589688801597",
  appId: "1:589688801597:web:0001f0bb40726633c21d54",
  measurementId: "G-2JM5E9VP40"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics not available:', error.message);
  }
}

// Export the app instance and config
export { firebaseConfig, analytics };
export default app;

console.log('🔥 Firebase initialized successfully!');
